import React, { PureComponent } from 'react';
import {
    Text,
    View,
    StyleSheet
} from 'react-native';
import { utils } from '@ltfe/ltfe-core-lib';
const { pt } = utils;

class Dashed extends PureComponent {
    render() {
        const { style, color, width, top, left, vertical } = this.props;

        const arr = [];

        let i;

        const len = ~~(width / pt(4));

        for (i = 0; i < len; i++) { arr.push(i); };

        return (
            <View style={ [st.con, style, { top, left }, vertical ? { height: width } : { width, flexDirection: 'row' }] }>
                {arr.map((val, key) => {
                    return <Text style={ [vertical ? st.vertical : st.item, { backgroundColor: color || '#FF6A00' }] } key={ key } />;
                })}
            </View>
        );
    }
}

const st = StyleSheet.create({
    con: {
        flexWrap: 'nowrap',
        justifyContent: 'space-between'
    },
    item: {
        height: pt(2),
        width: pt(2)
    },
    vertical: {
        width: pt(2),
        height: pt(2)
    }
});

export default Dashed;
